import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Header, Button, Grid, } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants'
import { firebaseAuth, logComponentLoad } from '../../../../config/constants.js'
import createBrowserHistory from 'history/createBrowserHistory';
import { getMainCardObjects, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import LargeProjectOrderEntry_card from './LargeProjectOrderEntry_card';
import ViewProject_header from './ViewProject_header';
const history = createBrowserHistory({ forceRefresh: true });

export default class LargeProjectOrderEntry_itemSelection extends Component {
    constructor(props) {
        super(props)

        this.state = ({
            loading: true,
            finalCardOrder: [],
            large_project_items: ''
        })
    }


    componentDidMount() {

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        if (returnObject.algoliaUser.perms.includes("largeProjectOrderEntry")) {
            logComponentLoad(returnObject, "LargeProjectOrderEntry_itemSelection");

            if (this.props.match.params.projectId) {
                console.log("projectId:" + this.props.match.params.projectId);

                //1. GET MAIN CARD OBJECTS FROM ALGOLIA
                getMainCardObjects("large_project_objects", this.setMainCardObjects);
            } else {
                alert("no probject id sent, pls double check url")
            }
        } else {
            logComponentLoad(returnObject, "FAILED - LargeProjectOrderEntry_itemSelection");
        }

    }

    //2. SET MAIN CARD OBJECTS
    setMainCardObjects = (objects) => {
        console.log("obx1 +++++++:setMainCardObjects");
        console.log("obx12 hits:" + JSON.stringify(objects, null, 3));

        this.setState({
            loading: false
        })

        if (objects.length > 0) {
            console.log("object is there...");

            this.setState({
                large_project_items: objects
            })
        }

    }

    render() {

        const itemArray = this.state.large_project_items.length != 0
            ? this.state.large_project_items.map((item) =>
                <Grid.Column>
                    <LargeProjectOrderEntry_card item={item} projectId={this.props.match.params.projectId} />
                </Grid.Column>
            )
            : ''

        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <div>
                {/* CLOSURE */}
                {/* <Image centered src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/closureNotices%2FPrintboda%20-%20covid%20-%20closed_5_siteImage-min.jpg?alt=media&token=432231de-4ede-40dc-a04d-701aa9e58cfa' /> */}

                <ViewProject_header projectId={this.props.match.params.projectId} user={this.state.user} />

                <br />
                <Button fluid color='green'>
                    <Link to={'/dashboard/viewLargeProject/' + this.props.match.params.projectId}>PROJECT HOME</Link>
                </Button>

                <Header as='h2' color='blue' textAlign='center' >
                    Select An Item
                    <Header.Subheader>
                        What Item to add to project?
                </Header.Subheader>
                </Header>

                <Grid container stackable columns={3}>
                    {itemArray}
                </Grid>

            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/LargeProjectOrderEntry_itemSelection.js